import config from 'config';
import { cdnTemplate, jadeLocals } from 'cdnPreprocessor';

export default [
  function homeImageCarousel() {
    return {
      restrict: 'E',
      template: require('./home-image-carousel.jade')(jadeLocals),
      link: (scope, el) => {
        let $owl = $(el).find('.owl-carousel'),
          dragging = false,
          singleTap = false,
          $next;

        const nextSlide = function(e) {
          if (e.keyCode == 13) {
            $owl.trigger('next.owl.carousel');

            setTimeout(() => {
              $owl.find('.owl-item.active > .carousel-item').focus();
            }, 250);
          }
        };

        $owl.owlCarousel({
          autoplay: true,
          autoplayTimeout: 10000,
          loop: true,
          autoplayHoverPause: true,
          responsive: {
            0: { items: 1, nav: false },
            769: { items: 1, nav: true }
          },
          onDrag: function(e) {
            dragging = true;
          },
          onInitialized: () => {
            $next = $owl.find('.owl-next');

            $next.attr('tabindex', '0').attr('aria-label', 'press enter to go to the next slide');

            $next.on('keyup', nextSlide);
          },
        });

        $('.carousel-item').on('touchend', function(e) {
          if (!singleTap) {
            singleTap = setTimeout(() => {
              singleTap = null
              if (!dragging) {
                window.location.href = this.dataset.href;
              } else {
                dragging = false;
              }
            }, 300);
          } else {
            clearTimeout(singleTap);
            singleTap = null;
            dragging = false;
          }
          e.preventDefault();
        });

        scope.carouselFocused = function(e) {
          $owl.trigger('stop.owl.autoplay');
          $owl.find('.owl-item.active > .carousel-item').attr('tabindex', 0);
        };

        scope.navigate = function(e) {
          if (e.keyCode == 13) {
            window.location.href = e.target.dataset.href;
          }
        };

        scope.slideFocused = function(e) {
          $owl.find('.carousel-item').attr('tabindex', -1);
        };

        scope.$on('$destroy', () => {
          $('.carousel-item').off();
          $next.off('keyup', nextSlide);
        });
      }
    }
  }
]


// WEBPACK FOOTER //
// ./source/client/layout-components/home-image-carousel/home-image-carousel.dir.js